// extracted by mini-css-extract-plugin
export default {"main":"AddCategory_main__aJr0M","body":"AddCategory_body__y1vA+","list":"AddCategory_list__k7tEa","btn":"AddCategory_btn__Lhvlq","header":"AddCategory_header__L6bCW"};